import {DiscordSnowflake} from '@colonist/types'
import {Events} from '@discord/embedded-app-sdk'
import {ShareActivityLinkAnalytics} from './entity_datas/EntityDatas'

export type DiscordEvent = Events

export interface UIDIFrameCommunicationMessageData {
    messageId?: string | undefined
    event?: string | undefined
    subscription?: DiscordEvent | undefined
    command?: UIDIFrameCommunicationCommandType | undefined
    data?: Record<string, unknown> | undefined
    args?: Record<string, unknown> | undefined
}

export enum UIDIFrameCommunicationCommandType {
    ChildReady = 'child-ready',
    Subscribe = 'subscribe',
    Unsubscribe = 'unsubscribe',
    SetActivity = 'set-activity',
    DispatchDiscordEvent = 'dispatch',
    OpenExternalLink = 'open-external-link',
    InviteFriends = 'invite-friends',
    Purchase = 'purchase',
    ShareMoment = 'share-moment',
    ShareActivityLink = 'share-activity-link',
}

export enum UIDCustomEvent {
    Ready = 'ready',
    ParentIFramePopup = 'parent-iframe-popup',
}

export enum UIDParentIFramePopupType {
    UserAlreadyHasMembershipError = 'user-already-has-membership-error'
}

export enum SDKRequest {
    PurchaseMembership,
    PurchaseGift,
    PurchaseCoins,
    InviteFriends,
    ShareMoment,
    OpenExternalLink,
    ShareActivityLink,
}

export interface UIDUserPermissions {
    canInviteFriends: boolean
}

export interface UIDServerProfile {
    username: string
    profilePictureUrl: string
    clientVersion: number
}

/* eslint-disable @typescript-eslint/naming-convention */
export interface UIDServerProfileAPIResponse {
    nick: string | null
    avatar: string | null
    user: UIDUserAPIResponse
}

export interface UIDUserAPIResponse {
    id: DiscordSnowflake
    username: string
    discriminator: string
    global_name?: string
    avatar: string | null
    locale?: string
    verified?: boolean
    email?: string | null
    flags?: number
    premium_type?: number
    public_flags?: number
}

export interface UIDServerAPIResponse {
    id: DiscordSnowflake
    name: string
    owner?: boolean
    approximate_member_count?: number
    approximate_presence_count?: number
    description?: string | null
    preferred_locale?: string
    vanity_url_code?: string | null
}

export interface ShareActivityLinkType {
    message: string
    referrerId: string
    referralTypeId: string
    analyticsPopupTriggered: ShareActivityLinkAnalytics
    analyticsPopupSuccess: ShareActivityLinkAnalytics
}
